import { ToEntity } from 'core/common/mappers';
import { PaymentFormData, PaymentFormMerchantData, PaymentFormPaypalData } from '../entities';
import { PaymentFormDataDto } from '../services/dto';

export class PaymentFormDataDtoMapper implements ToEntity<PaymentFormData, PaymentFormDataDto> {
  toEntity(dto: PaymentFormDataDto): PaymentFormData {
    return {
      formMerchantData: this.mapMerchantDataDtoToEntity(dto),
      paypalPaymentData: this.mapPaypalDataDtoToEntity(dto),
    };
  }

  private mapMerchantDataDtoToEntity(dto: PaymentFormDataDto): PaymentFormMerchantData | null {
    if (!('merchant_data' in dto)) {
      return null;
    }

    return {
      merchant: dto.merchant_data.merchant_id,
      paymentIntent: dto.merchant_data.payment_intent,
      signature: dto.merchant_data.signature,
    };
  }

  private mapPaypalDataDtoToEntity(dto: PaymentFormDataDto): PaymentFormPaypalData {
    if (!('paypal_payment_script' in dto)) {
      return '';
    }

    return dto.paypal_payment_script;
  }
}
